import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {
  convertToKebabCase,
  formatCurrency,
  getCurrencySymbol,
  getDecimalSeparator,
  formatIntNumber,
  formateDateTime,
  getSubscriptionStatus
} from './../../../utils/utils';
import { User } from '../../../models/user';
import { EMPTY, Subject, Subscription } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { cloneDeep as _cloneDeep, isEqual as _isEqual } from 'lodash';
import { UserService } from 'src/app/services/user.service';
import { Credits } from '../../../models/credits';
import { creditsTypeIcon } from '../../../utils/constants';
import { MenuService } from '../../../services/menu.service';
import { ROLE_ADMIN_ID, ROLE_OWNER_ID } from '../../../models/role';
import { SessionStorageService } from 'ngx-webstorage';
import { Domain } from '@models/domain';
import { DomainService } from '@services/domain.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { UntypedFormControl } from '@angular/forms';
import { CreditsService } from '@services/credits.service';

@Component({
  selector: 'wsb-ui-dropdown-credits',
  templateUrl: './dropdown-credits.component.html',
  styleUrls: ['./dropdown-credits.component.scss'],
  animations: [
    trigger('rotateTriangle', [
      state('left', style({ transform: 'rotate(0)' })),
      state('bottom', style({ transform: 'rotate(90deg)' })),
      transition('left => bottom', [animate('200ms ease-out', style({ transform: 'rotate(90deg)' }))]),
      transition('bottom => left', animate('200ms ease-out', style({ transform: 'rotate(0)' })))
    ])
  ],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class DropdownCreditsComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('creditsTab') creditsTab: TemplateRef<any>;
  @ViewChild('subscriptionsTab') subscriptionsTab: TemplateRef<any>;
  @Input() credit: Credits;
  @Input() openSubs = false;
  @Input() creditsList = [];
  @Input() user: User;
  @Input() creditsUpdateInProgress: boolean;
  @Output() creditsListChanged = new EventEmitter();
  bundle;
  subBundled = [];
  singleSub = [];
  creditsObservable$ = new Subject<any[]>();
  creditListPrev;
  menuEntries = {};
  private menuEntriesSubscription: Subscription;
  domain: Domain | null;
  tabOrder = [];
  switchTabOrderBrandList = ['mediaburst', 'skebby', 'smsenvoi', 'mobytfr'];
  activeId = 1;
  changeTabOrder = false;
  showNationCredits: UntypedFormControl = new UntypedFormControl(false);
  convertToKebabCase = convertToKebabCase;
  locale = 'it-IT';
  maxSelectableCredits = 3;
  decimalSeparator;
  currency;
  formatIntNumber;
  allowProfileManageAndShopAndBilling: any;
  isSubaccount: any;
  countsCreditsChecked = 0;
  rotationState = 'left';
  addCSSClass = false;
  hasNations = false;

  headarSubscription: Subscription;

  constructor(
    private userService: UserService,
    private menuService: MenuService,
    private sessionStorage: SessionStorageService,
    private cdRef: ChangeDetectorRef,
    private domainService: DomainService,
    private creditsService: CreditsService
  ) {}

  ngOnInit() {
    setTimeout(() => {
      for (const i in this.creditsList) {
        if (this.creditsList[i].enabled && this.countsCreditsChecked < this.maxSelectableCredits) {
          this.countsCreditsChecked++;
        } else {
          this.creditsList[i].enabled = false;
          this.updateCreditsPreferences();
        }
      }
      const creditsNation = this.creditsList.filter(credit => credit.isNation === true);
      if (creditsNation.length > 0) {
        this.hasNations = true;
      }
      if (creditsNation.length > 9) {
        this.addCSSClass = true;
      }
    });

    this.creditsService.getUserCredits().subscribe(credits => {
      this.credit = credits;
      this.checkIfBundle();
    });

    this.domainService.getDomainState().subscribe(domain => {
      this.domain = domain;
    });

    this.isSubaccount = this.userService.isSubaccount();

    this.creditListPrev = _cloneDeep(this.creditsList);
    this.creditsObservable$
      .pipe(
        debounceTime(1000),
        switchMap(updatedCredits => {
          if (this.creditsUpdateInProgress) {
            return EMPTY;
          }
          this.currency = getCurrencySymbol();
          const creditsPreferencesMatch = _isEqual(_cloneDeep(this.creditListPrev), _cloneDeep(updatedCredits));
          if (!creditsPreferencesMatch) {
            this.creditListPrev = _cloneDeep(updatedCredits);
            const previousDisplayCredits = _cloneDeep(this.user);
            const displayCreditsUpdated = updatedCredits
              .filter(creditType => creditType.enabled === true)
              .map(creditType => creditType.credits.type);
            this.user.preferences.displayCredits = displayCreditsUpdated;
            return this.userService.updateUserProfile(previousDisplayCredits, this.user);
          }
          return EMPTY;
        })
      )
      .subscribe(updatedUser => {
        this.user = updatedUser;
        this.allowProfileManageAndShopAndBilling =
          this.sessionStorage.retrieve('wsb-userprofile-role') === ROLE_OWNER_ID ||
          this.sessionStorage.retrieve('wsb-userprofile-role') === ROLE_ADMIN_ID;
      });

    this.menuEntriesSubscription = this.menuService.getMenuEntriesState().subscribe(entries => (this.menuEntries = entries));
    this.allowProfileManageAndShopAndBilling =
      this.sessionStorage.retrieve('wsb-userprofile-role') === ROLE_OWNER_ID ||
      this.sessionStorage.retrieve('wsb-userprofile-role') === ROLE_ADMIN_ID;

    this.decimalSeparator = getDecimalSeparator();
    this.currency = getCurrencySymbol();
    this.formatIntNumber = formatIntNumber;

    this.updateHeaderSubscriptionByImpersonate();
  }
  // when super impersonate sub
  updateHeaderSubscriptionByImpersonate() {
    this.headarSubscription = this.userService.headerSubscription.subscribe(subscription => {
      this.checkIfBundle(true, subscription);
    });
  }

  getBrandInfo() {
    if (this.switchTabOrderBrandList.includes(this.sessionStorage.retrieve('wsb-brand-name'))) {
      this.tabOrder = [this.subscriptionsTab, this.creditsTab];
      if (this.openSubs) {
        this.activeId = 1;
      }
      this.changeTabOrder = true;
    } else {
      this.tabOrder = [this.creditsTab, this.subscriptionsTab];
      if (this.openSubs) {
        this.activeId = 2;
      }
    }
  }

  ngAfterViewInit(): void {
    this.getBrandInfo();
    this.cdRef.detectChanges();
  }

  updateCreditsPreferences() {
    this.creditsListChanged.emit(this.creditsList);
    this.creditsObservable$.next(_cloneDeep(this.creditsList));
  }

  get userIdKey() {
    return this.sessionStorage.retrieve('wsb-user-key');
  }

  get counterCurrentCredits() {
    if (this.creditsList && this.creditsList.length > 0) {
      return this.creditsList.filter(credit => credit.enabled).length;
    }
    return 0;
  }

  toggleNationsCredits() {
    this.showNationCredits.setValue(!this.showNationCredits.value);

    if (this.rotationState === 'left') {
      this.rotationState = 'bottom';
    } else {
      this.rotationState = 'left';
    }
  }

  //
  // getBrowserNumberFormat(): any {
  //   return {
  //     thousandsSeparator: Number(10000)
  //       .toLocaleString()
  //       .charAt(2),
  //     decimalSeparator: Number(1.1)
  //       .toLocaleString(this.user.preferences.language.substr(0, 2))
  //       .charAt(1)
  //   };
  // }

  private checkIfBundle(isImpersonate?: boolean, subscriptionData?): void {
    if (isImpersonate) {
      this.singleSub = [];
      this.subBundled = [];
    }
    const subscriptions = subscriptionData ? subscriptionData : this.credit.subscriptions;

    this.bundle = subscriptions.find(subscription => subscription.type === 'bundle');
    this.getSubscription(subscriptions);
  }

  getSubscription(subscriptions) {
    subscriptions.forEach(sub => {
      if (sub.details.bundled) {
        return this.subBundled.push(sub);
      }

      if (sub.type === 'bundle') {
        return;
      }

      this.singleSub.push(sub);
    });

    // for (const iterator of this.credit.subscriptions) {
    //   if (iterator.details.bundled) {
    //     return subBundled.push(iterator);
    //   }
    //   singleSub.push(iterator);
    // }

    // switch (iterator.type) {
    //   case 'pages':
    //     if (iterator.details.bundled) {
    //       return subBundled.push(iterator);
    //     }
    //     singleSub.push(iterator);
    //     break;
    //   case 'email':
    //     if (iterator.details.bundled) {
    //       return subBundled.push(iterator);
    //     }
    //     singleSub.push(iterator);
    //     break;
    //   case 'sms':
    //     if (iterator.details.bundled) {
    //       return subBundled.push(iterator);
    //     }
    //     singleSub.push(iterator);
    //     break;
    //   case 'richsms':
    //     if (iterator.details.bundled) {
    //       return subBundled.push(iterator);
    //     }
    //     singleSub.push(iterator);
    //     break;
    //   case 'sr':
    //     break;
    //   case 'rpc':
    //     break;

    //   default:
    //     break;
    // }
  }

  get creditFormatted() {
    if (this.credit && this.credit.money !== null) {
      return formatCurrency(this.credit.money);
    }
    return null;
  }

  get creditFormattedDigits() {
    if (this.creditFormatted) {
      return this.creditFormatted.split(getDecimalSeparator())[0];
    }

    return null;
  }

  get creditFormattedFractions() {
    if (this.creditFormatted) {
      return this.creditFormatted.split(getDecimalSeparator())[1];
    }

    return null;
  }

  get disableExtraCredits() {
    if (this.counterCurrentCredits >= this.maxSelectableCredits) {
      return true;
    }

    return false;
  }

  formateDate(date) {
    return formateDateTime(date, false);
  }

  iconByCreditType(type) {
    return creditsTypeIcon[type];
  }

  ngOnDestroy(): void {
    this.creditsObservable$.unsubscribe();
    this.menuEntriesSubscription.unsubscribe();
    this.headarSubscription.unsubscribe();
  }

  isActiveSubscriptionTrial(trial) {
    let isActive = false;
    if (trial.type === 'pages') {
      isActive = trial.details?.note ? true : false;
    }
    return isActive;
  }

  subscriptionWarning(sub) {
    if (!sub.details.recurringSubscription) {
      return getSubscriptionStatus(sub.details.subscriptionExpiryTime);
    }
    return 'recurringSubscription';
  }

  displayCreditsMovementsForSubAccounts() {
    return this.isSubaccount;
  }
}
